// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Spaces from "../theme/Spaces.res.js";
import * as Primitive_int from "@rescript/runtime/lib/es6/Primitive_int.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  container: {
    "display-k1xSpc": "display-x78zum5",
    $$css: "wino-gc:src/resources/layout-and-structure/Group.res.js:11"
  }
};
function containerStyleProps(wrap, spaceX, spaceY, alignY) {
  let columnGapStr = String(Spaces.toFloat(spaceX));
  let rowGapStr = String(Spaces.toFloat(spaceY));
  return Stylex.props(styles.container, {
    columnGap: columnGapStr + `px`,
    rowGap: rowGapStr + `px`
  }, {
    flexWrap: wrap ? "wrap" : "nowrap"
  }, {
    alignItems: alignY
  });
}
function itemFlex(flexBasis, gapPx, gridLength, grow) {
  switch (flexBasis) {
    case "fit-content":
    case "max-content":
    case "min-content":
      return ["0", "0", flexBasis];
    default:
      let match = flexBasis.split("fr");
      if (match.length === 2) {
        let fraction = match[0];
        let match$1 = match[1];
        if (match$1 === "") {
          return [fraction === "" ? "1" : fraction, "1", "0"];
        }
      }
      return [grow ? "1" : "0", "1", `calc(` + flexBasis + ` - ` + gapPx + ` / ` + gridLength + ` * (` + gridLength + ` - 1))`];
  }
}
function itemStyleProps(flexBasis, spaceX, gridLength, wrap, grow, stretch) {
  let gapPx = String(Spaces.toFloat(spaceX)) + `px`;
  let gridLength$1 = String(gridLength);
  let match = itemFlex(flexBasis, gapPx, gridLength$1, grow);
  return Stylex.props({
    alignItems: stretch ? "stretch" : "flex-start",
    display: "flex",
    flexBasis: match[2],
    flexGrow: match[0],
    flexShrink: match[1],
    minWidth: wrap ? "auto" : "0px"
  });
}
function Group(props) {
  let __alignY = props.alignY;
  let __spaceY = props.spaceY;
  let __spaceX = props.spaceX;
  let __grow = props.grow;
  let __wrap = props.wrap;
  let grid = props.grid;
  let children = props.children;
  let wrap = __wrap !== undefined ? __wrap : true;
  let grow = __grow !== undefined ? __grow : true;
  let spaceX = __spaceX !== undefined ? __spaceX : "large";
  let spaceY = __spaceY !== undefined ? __spaceY : "large";
  let alignY = __alignY !== undefined ? __alignY : "flex-start";
  let stretch = Stdlib_Option.getOr(props.stretch, grow);
  let childrenLength = React.Children.toArray(children).length;
  let defaultFlexBasisPct = Math.max(Primitive_int.div(100, childrenLength) - childrenLength | 0, childrenLength - 2 | 0);
  let containerStyleProps$1 = containerStyleProps(wrap, spaceX, spaceY, alignY);
  return JsxRuntime.jsx("div", {
    children: React.Children.toArray(children).map((child, idx) => {
      let flexBasis = Stdlib_Option.getOr(Stdlib_Option.flatMap(grid, grid => grid[Primitive_int.mod_(idx, grid.length)]), String(defaultFlexBasisPct) + `%`);
      let match = itemStyleProps(flexBasis, spaceX, Stdlib_Option.mapOr(grid, childrenLength, value => value.length), wrap, grow, stretch);
      let rootKey = Stdlib_Option.getOr(grid, []).join("");
      return JsxRuntime.jsx("div", {
        children: child,
        className: match.className,
        style: match.style
      }, rootKey + idx.toString());
    }),
    className: containerStyleProps$1.className,
    role: "presentation",
    style: containerStyleProps$1.style
  });
}
let make = React.memo(Group);
export { make };
/* styles Not a pure module */